module.exports = __webpack_public_path__ + "media/images/card_mastercard-4ef585c2a551a8f29de0ba9353b913d2.jpg";